import { LeftArrow, RightArrow } from 'assests/GmsIcons';
import React from 'react';

type TArrowButtonProps = {
    onClick?: () => void;
    className?: string;
    direction?: 'left' | 'right';
}

const ArrowButton = ({ onClick, className, direction = 'left' }: TArrowButtonProps) => {
    const ArrowIcon = direction === 'left' ? LeftArrow : RightArrow;

    return (
        <button 
            onClick={onClick} 
            type="button"
            style={{ 
                borderColor: '#0747A6', 
                borderWidth: '1px', 
                borderStyle: 'solid',
                backgroundColor: 'white',
            }}
            className={`
                tw-w-6 
                tw-h-6
                aria-hidden="true" 
                tw-bg-white 
                tw-rounded-md 
                tw-flex 
                tw-items-center 
                tw-justify-center 
                tw-shadow-[0_2px_8px_rgba(0,0,0,0.04)]
                hover:tw-bg-[#F4F5F7]
                active:tw-bg-[#EBECF0]
                hover:tw-border-[#0052CC]
                active:tw-border-[#0747A6]
                tw-transition-all
                tw-duration-200
                ${className || ''}
            `}
        >
            <ArrowIcon />
        </button>
    );
};

export const LeftButton = (props: Omit<TArrowButtonProps, 'direction'>) => (
    <ArrowButton {...props} direction="left" />
);

export const RightButton = (props: Omit<TArrowButtonProps, 'direction'>) => (
    <ArrowButton {...props} direction="right" />
);

export default ArrowButton;